// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2rFZZ","imageUploader":"EGiftCard_imageUploader__m4Bud"};